export const EXPECTED_SORT_CATEGORIES = Object.freeze({
  HOTEL: "hotel",
  FLYER: "flyer",
  FRIEND: "friend",
  SOCIAL_MEDIA: "socialMedia",
});

export const ANY_NUMBERS = /\d/;
export const ONLY_NUMBERS_WITHOUT_ZERO = /^[1-9][0-9]*$/;
